import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CountryService {
  private url = environment.api;

  constructor(private http: HttpClient) {}

  getCountry() {
    const path = `${this.url}/api/v1/countries/filter-country`;
    return this.http.post(path, '');
  }
}

export default CountryService;
